export default function ServicesSection() {
  const services = [
    {
      id: 1,
      title: "Financiamento Imobiliário",
      description:
        "Realize o sonho da casa própria com as melhores taxas do mercado. Financie seu imóvel novo ou usado com condições exclusivas e parcelas que cabem no seu bolso.",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20family%20home%20with%20garden%20at%20golden%20hour%2C%20warm%20cozy%20lighting%20from%20windows%2C%20suburban%20residential%20architecture%2C%20clean%20teal%20sky%20background%2C%20professional%20real%20estate%20photography%2C%20inviting%20home%20entrance%2C%20high%20detail%20quality&width=600&height=400&seq=financiamento-2026-x1&orientation=landscape",
      icon: "ri-home-5-line",
      features: ["Taxas a partir de 8,99% a.a.", "Até 420 meses para pagar", "Financiamento de imóveis novos e usados"],
      cta: "Simular Financiamento",
    },
    {
      id: 2,
      title: "Home Equity",
      description:
        "Use seu imóvel como garantia para obter crédito com taxas reduzidas. Ideal para quem precisa de capital para investimentos, quitação de dívidas ou reformas.",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20luxury%20house%20interior%20living%20room%20with%20large%20windows%2C%20natural%20light%20streaming%20in%2C%20elegant%20furniture%2C%20minimal%20decor%2C%20warm%20neutral%20and%20teal%20accents%2C%20professional%20interior%20photography%2C%20spacious%20bright%20ambiance&width=600&height=400&seq=homeequity-2026-x1&orientation=landscape",
      icon: "ri-key-2-line",
      features: ["Taxas a partir de 1,29% a.m.", "Até 60% do valor do imóvel", "Liberdade para usar o crédito"],
      cta: "Simular Home Equity",
    },
    {
      id: 3,
      title: "Consórcio",
      description:
        "A melhor forma de programar a compra do seu imóvel. Sem juros, sem entrada e com parcelas que se ajustam ao seu orçamento. Contemplação por lance ou sorteio.",
      image:
        "https://readdy.ai/api/search-image?query=Abstract%20conceptual%20illustration%20of%20financial%20growth%20and%20home%20ownership%20pathway%2C%20geometric%20staircase%20ascending%20towards%20a%20modern%20house%20silhouette%20at%20the%20top%2C%20warm%20golden%20sunlight%20rays%2C%20soft%20teal%20and%20cream%20gradient%20background%2C%20minimalist%20flat%20design%20with%20subtle%20texture%2C%20coins%20and%20small%20savings%20icons%20scattered%20along%20the%20path%2C%20editorial%20illustration%20style%20with%20clean%20lines%20and%20harmonious%20warm%20neutral%20color%20palette%20conveying%20progress%2C%20trust%20and%20achievement&width=600&height=400&seq=consorcio-2026-v2&orientation=landscape",
      icon: "ri-hand-coin-line",
      features: ["Sem juros e sem entrada", "Parcelas fixas e programadas", "Contemplação por lance ou sorteio"],
      cta: "Simular Consórcio",
    },
  ];

  return (
    <section id="servicos" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            Nossos Serviços
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Soluções Financeiras para Você
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Oferecemos as melhores opções de crédito imobiliário, com condições
            exclusivas e atendimento personalizado para cada necessidade.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 hover:shadow-lg"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white">
                  <i className={`${service.icon} text-lg`}></i>
                </div>
              </div>
              <div className="p-6 space-y-4">
                <h3 className="font-heading text-xl font-bold text-foreground-950">
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-2 text-sm text-foreground-700"
                    >
                      <i className="ri-check-line text-primary-500 text-sm"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/5511985860949"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors pt-2"
                >
                  {service.cta}
                  <i className="ri-arrow-right-line text-sm"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}